import EquipmentInOutServer from '../../api/equipment_in_out/index'

export default {

    namespaced: true,

    state: {

        dialogVflag: false,

        equinoutid: '',

        equipmentuid: '',

        equipment_io_searchInfo: {
            equipmentInOut: {
                equinoutid: '',
                depts: [],
            },
            currentPage: 1,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
        },

        equipment_io_tableData: [],

        equipment_io_pageInfo: {},

    },

    getters: {

        dialogVflag(state) {
            return state.dialogVflag;
        },

        equinoutid(state) {
            return state.equinoutid;
        },

        equipmentuid(state) {
            return state.equipmentuid;
        },

        equipment_io_searchInfo(state) {
            return state.equipment_io_searchInfo;
        },

        equipment_io_tableData(state) {
            return state.equipment_io_tableData;
        },

        equipment_io_pageInfo(state) {
            return state.equipment_io_pageInfo;
        }

    },

    mutations: {

        changeDialogVflag(state, payload) {
            state.dialogVflag = payload;
        },

        changeEquinoutid(state, payload) {
            state.equinoutid = payload;
        },

        changeEquipmentuid(state, payload) {
            state.equipmentuid = payload;
        },

        changeEquipment_io_searchInfo(state, payload){
            state.equipment_io_searchInfo.equipmentInOut.equinoutid = '-1';
        },

        changeEquipmentIoInfoPage(state, payload) {
            state.equipment_io_tableData = payload.tableData;
            state.equipment_io_pageInfo = {
                total: payload.total,
                currentPage: payload.currentPage,
                pageSize: payload.pageSize,
                pageSizes: payload.pageSizes,
            };
        }

    },

    actions: {

        pageEquipmentIoInfo({commit}, payload) {
            commit("changeEquipmentIoInfoPage", {
                tableData: [],
                total: 0,
                currentPage: payload.currentPage,
                pageSize: payload.pageSize,
                pageSizes: payload.pageSizes,
            })
            if(payload.equipmentInOut.equinoutid != ''){
                EquipmentInOutServer.equipmentIoInfo.page(payload, {
                    headers: {
                        orgId: localStorage.getItem("authorg"),
                        sites: localStorage.getItem("authsites"),
                    }
                }).then((responseBody) => {
                    commit("changeEquipmentIoInfoPage", {
                        tableData: responseBody.data.data.pageData,
                        total: responseBody.data.data.total,
                        currentPage: payload.currentPage,
                        pageSize: payload.pageSize,
                        pageSizes: payload.pageSizes,
                    })
                });
            }
        },

        deleteEquipmentIoInfo({commit}, payload) {
            return EquipmentInOutServer.equipmentIoInfo.delete(payload, null);
        },

        queryEquipmentIoDetail({commit}, payload) {
            return EquipmentInOutServer.equipmentIoInfo.get(payload);
        }


    },

}
